import type React from 'react';
import { memo } from 'react';

import cn from '../../../../utils/cn';
import Divider from '../../../Divider';

export interface DropdownHeaderProps {
  className?: string;
  children: React.ReactNode;
}

const DropdownHeader = ({ children, className }: DropdownHeaderProps) => (
  <>
    <div className={cn('flex', className)}>{children}</div>
    <Divider />
  </>
);

export default memo(DropdownHeader);
